import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { MarketdateExpenseComponent } from './marketdate-expense.component';
import { MarketdateExpenseDetailComponent } from './marketdate-expense-detail.component';
import { MarketdateExpensePopupComponent } from './marketdate-expense-dialog.component';
import { MarketdateExpenseDeletePopupComponent } from './marketdate-expense-delete-dialog.component';

import { Principal } from '../../shared';

export const marketdateExpenseRoute: Routes = [
  {
    path: 'marketdate-expense',
    component: MarketdateExpenseComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'marketdate-expense/:id',
    component: MarketdateExpenseDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];

export const marketdateExpensePopupRoute: Routes = [
  {
    path: 'marketdate-expense-new',
    component: MarketdateExpensePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-expense/:id/edit',
    component: MarketdateExpensePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  },
  {
    path: 'marketdate-expense/:id/delete',
    component: MarketdateExpenseDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'marketmanagerApp.marketdateExpense.home.title'
    },
    canActivate: [UserRouteAccessService],
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-expense/marketdate-expense.route.ts